import React, {FC, useContext} from 'react';
import {ModerationUser} from "interfaces";
import {AuthContext} from "contexts";
import {toDateString} from "utils";

interface Props {
    user: ModerationUser
}

export const SubscriptionsHistory: FC<Props> = ({user}) => {
    const {user: myUser} = useContext(AuthContext);

    if (!myUser?.isSuperAdmin || !user.subscriptionHistory?.length) {
        return null;
    }

    return <>
        <hr/>
        <table className="table-light w-100">
            <thead>
            <tr>
                <td className="fw-semibold" style={{paddingRight: 10}}>Тип</td>
                <td className="fw-semibold" style={{paddingRight: 10}}>ID</td>
                <td className="fw-semibold" style={{paddingRight: 10}}>Продление</td>
                <td className="fw-semibold" style={{paddingRight: 10}}>Начало</td>
                <td className="fw-semibold" style={{paddingRight: 10}}>Окончание</td>
                <td className="fw-semibold">Количество дней</td>
            </tr>
            </thead>
            <tbody>
            {user.subscriptionHistory.map(h => {
                    const timeDiff = h.expiresDate && h.date ? h.expiresDate.getTime() - h.date.getTime() : undefined;
                    const daysDiff = timeDiff ? Math.round(timeDiff / (1000 * 3600 * 24)) : undefined;
                    return <tr key={toDateString(h.date)}>
                        <td className="fw-semibold" style={{paddingRight: 10}}>{h.type}</td>
                        <td style={{paddingRight: 10}}>{h.productId}</td>
                        <td style={{paddingRight: 10}}>{h.isRenewal ? 'Да' : ''}</td>
                        <td style={{paddingRight: 10}}>{toDateString(h.date, false)}</td>
                        <td style={{paddingRight: 10}}>{toDateString(h.expiresDate, false)}</td>
                        <td>{daysDiff}</td>
                    </tr>
                }
            )}
            </tbody>
        </table>
    </>
}

